import { useQuery } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth';
import fetchCountriesData from '../Services/fetchCountriesData';

export default function useCountriesData() {
	const { accessToken } = useAuth();

	const countriesQuery = useQuery({
		queryKey: ['countries'],
		queryFn: () => fetchCountriesData({ accessToken }),
		staleTime: Infinity,
		retry: false,
	});

	return countriesQuery;
}
